var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarProfilebuilder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.57,
    height: 13.571,
    viewBox: "0 0 13.57 13.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "users",
    d: "M4.241,7.351A2.545,2.545,0,1,1,6.785,4.806,2.545,2.545,0,0,1,4.241,7.351Zm4.241,3.958A2.831,2.831,0,0,0,5.654,8.482H2.827A2.831,2.831,0,0,0,0,11.309v2.262H8.481ZM9.9,5.089A2.545,2.545,0,1,1,12.44,2.545,2.545,2.545,0,0,1,9.9,5.089Zm.848,1.131H7.916a2.71,2.71,0,0,0-.3.03A3.683,3.683,0,0,1,6.729,7.5a3.963,3.963,0,0,1,2.884,3.806H13.57V9.047A2.831,2.831,0,0,0,10.743,6.22Z",
    transform: "translate(0 0)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProfilebuilder);
export default __webpack_public_path__ + "static/media/sidebar-profilebuilder.927db94801beae4e81075b31d2621803.svg";
export { ForwardRef as ReactComponent };